<div class="col-12 p-1 mt-3">
  <ul class="rounded list-unstyled" [ngStyle]="{'color': menu.colorText, 'border-color': menu.colorText}">
    <li class="p-2" [hidden]="section.items[0].comment === 'separator'">
      <ng-container [ngTemplateOutlet]="headers"></ng-container>
    </li>
    <li *ngFor="let item of section.items" class="p-2">
      <div *ngIf="item.comment === 'separator'">
        <app-separator [menu]="menu" [separator]="item"></app-separator>
        <ng-container [ngTemplateOutlet]="headers"></ng-container>
      </div>
      <div class="row" *ngIf="item.comment !== 'separator'">
        <div class="col-3 text-left {{menu.fontHeader}}" translate="no">
          <h5 [ngStyle]="{'color': menu.colorText}" *ngIf="!item.photo">
            <ng-container *ngIf="!section.upperCaseName">
              {{ item.name | firstuppercase }}
            </ng-container>
            <ng-container *ngIf="section.upperCaseName">
              {{ item.name | uppercase }}
            </ng-container>
          </h5>
          <div *ngIf="item.photo">
            <img [src]="item.photo" *ngIf="item.photo && item.photo !== ''" style="max-width: 80%; height: auto;">
          </div>
        </div>
        <ng-container *ngIf="item.comment !== 'separator'">
          <div class="col-3 font-weight-bold text-right {{menu.fontText}}" *ngIf="item.availableDrink === 'S' && item?.price?.toString() !== '0'" translate="no">
            {{ item.price | typeNumber: menu.units}}
          </div>
          <div class="col-3 font-weight-bold text-right {{menu.fontText}}" *ngIf="item.availableDrink === 'N' || item?.price?.toString() === '0'">
            --
          </div>
          <div class="col-3 font-weight-bold text-right {{menu.fontText}}" *ngIf="item?.priceMidle?.toString() !== '0'" translate="no">
            {{ item?.priceMidle! | typeNumber: menu.units}}
          </div>
          <div class="col-3 font-weight-bold text-right {{menu.fontText}}" *ngIf="item?.priceMidle?.toString() === '0'">
            --
          </div>
          <div class="col-3 font-weight-bold text-right {{menu.fontText}}" *ngIf="item.availableBotle === 'S' && item?.priceBottle?.toString() !== '0'" translate="no">
            {{ item?.priceBottle! | typeNumber: menu.units}}
          </div>
          <div class="col-3 font-weight-bold text-right {{menu.fontText}}" *ngIf="item.availableBotle === 'N' || item?.priceBottle?.toString() === '0'">
            --
          </div>
        </ng-container>

      </div>
    </li>
  </ul>
</div>


<ng-template #headers>
  <div class="row justify-content-around">
    <div class="col-3 text-left">
    </div>
    <div class="col-3 font-weight-bold text-right text-underline {{menu.fontHeader}}" translate="no">
      {{ language === 'ES'? 'Trago': 'Shot' }}
    </div>
    <div class="col-3 font-weight-bold text-right text-underline {{menu.fontHeader}}" translate="no">
      {{ language === 'ES'? 'Media': 'Half' }}
    </div>
    <div class="col-3 font-weight-bold text-right text-underline {{menu.fontHeader}}" translate="no">
      {{ language === 'ES'? 'Botella': 'Bottle' }}
    </div>
  </div>
</ng-template>